import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import hljs from 'highlight.js'
import cpp from 'highlight.js/lib/languages/cpp'

import 'highlight.js/styles/gruvbox-dark.css'

hljs.registerLanguage('cpp', cpp);

const app = createApp(App);
app.use(router, hljs.vuePlugin);
app.mount('#app');